import { render, staticRenderFns } from "./popup-card.vue?vue&type=template&id=c8d4b232&scoped=true&"
import script from "./popup-card.ts?vue&type=script&lang=ts&"
export * from "./popup-card.ts?vue&type=script&lang=ts&"
import style0 from "./popup-card.scss?vue&type=style&index=0&id=c8d4b232&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d4b232",
  null
  
)

export default component.exports